import Reporting from './Reporting';

export default Reporting;
